import { combineReducers, createStore } from 'redux';
import snackbarReducer from './reducers/snackbar';
import dialogReducer from './reducers/dialog';

const reducer = combineReducers({
  snackbar: snackbarReducer,
  dialog: dialogReducer,
});

const store = createStore(reducer, {});

export default store;
